/** backoffice copy. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enBackoffice = {
  // ---- Navigation & shared ------------------------------------------------------------
  'bo.nav.dashboard': 'Dashboard',
  'bo.nav.group.overview': 'Overview',
  'bo.nav.group.tables': 'Tables',
  'bo.nav.group.cash': 'Cash & reconciliation',
  'bo.nav.group.approvalQueue': 'Queue',
  'bo.nav.group.branchSettings': 'Branch settings',
  'bo.nav.floors': 'Floors & tables',
  'bo.nav.menu': 'Menu',
  'bo.nav.pricing': 'Price governance',
  'bo.pricing.title': 'Price governance',
  'bo.pricing.subtitle': 'Review, schedule, and publish selling prices by sales channel.',
  'bo.pricing.new': 'New price version',
  'bo.pricing.name': 'Version name',
  'bo.pricing.effective': 'Effective time',
  'bo.pricing.matrix': 'Channel price matrix',
  'bo.pricing.matrixDesc': 'Every active menu item needs a price for every channel.',
  'bo.pricing.history': 'Version history',
  'bo.pricing.version': 'Version',
  'bo.pricing.lines': '{count} channel prices',
  'bo.pricing.create': 'Create draft',
  'bo.pricing.submit': 'Submit for approval',
  'bo.pricing.approve': 'Approve and schedule',
  'bo.pricing.rollback': 'Create rollback draft',
  'bo.pricing.created': 'Price version {version} created.',
  'bo.pricing.submitted': 'Price version submitted.',
  'bo.pricing.approved': 'Price version approved.',
  'bo.pricing.rollbackCreated': 'Rollback draft created.',
  'bo.pricing.empty': 'No price versions are available.',
  'bo.pricing.makerChecker': 'A different price manager must approve a submitted version.',
  'bo.pricing.channel.walk_in': 'Dine-in / takeaway',
  'bo.pricing.channel.gofood': 'GoFood',
  'bo.pricing.channel.grabfood': 'GrabFood',
  'bo.pricing.channel.shopeefood': 'ShopeeFood',
  'bo.pricing.channel.other': 'Other delivery',
  'bo.nav.stations': 'Kitchen stations',
  'bo.nav.staff': 'Staff',
  'bo.nav.shifts': 'Cash shifts',
  'bo.nav.reports': 'Reports',
  'bo.nav.branches': 'Branches',
  'bo.nav.approvals': 'Approvals',
  'bo.nav.approvalsBadge': '{count} waiting for you',
  'bo.nav.budgets': 'Budgets',
  'bo.nav.approvalPolicies': 'Approval policies',
  'bo.nav.ap': 'Payables',
  'bo.nav.apSections': 'Payables sections',
  'bo.nav.apInvoices': 'Invoices',
  'bo.nav.apPayments': 'Payments',
  'bo.nav.apCreditNotes': 'Credit notes',
  'bo.nav.apAging': 'Aging',
  'bo.nav.apSettings': 'Matching settings',
  'bo.nav.reconciliation': 'Reconciliation',
  'bo.nav.settings': 'Settings',
  'bo.noBranch.text':
    'This page works per branch, and there is no branch yet. Create a branch first — its data appears here afterwards.',
  'bo.noBranch.link': 'Go to Branches',
  'bo.col.active': 'Active',
  'bo.col.actions': 'Actions',
  'bo.inactiveOption': '{name} (inactive)',
  'bo.form.nameRequired': 'Enter a name.',
  'bo.form.tooLong': 'Use at most {max} characters.',
  'bo.form.sortOrder': 'Sort order',
  'bo.form.sortOrderHint': 'Lower numbers are listed first.',
  'bo.form.sortInvalid': 'Enter a whole number (0 or more).',

  // ---- Ranges ------------------------------------------------------------------------
  'bo.range.label': 'Date range',
  'bo.range.1d': 'Today',
  'bo.range.7d': '7 days',
  'bo.range.30d': '30 days',
  'bo.range.between': '{from} – {to}',

  // ---- Metrics -----------------------------------------------------------------------
  'bo.metric.grossSales': 'Gross sales',
  'bo.metric.grossSales.desc': 'Item prices incl. modifiers, before service charge and tax.',
  'bo.metric.grossSales.hint': 'From {bills} settled bills',
  'bo.metric.bills': 'Bills',
  'bo.metric.bills.desc': 'Settled bills in the range.',
  'bo.metric.averageCheck': 'Average check',
  'bo.metric.averageCheck.desc': 'Total collected per settled bill.',
  'bo.metric.guests': 'Guests',
  'bo.metric.guests.desc': 'Guests seated on settled bills.',
  'bo.metric.itemsSold': 'Items sold',
  'bo.metric.itemsSold.desc': 'Quantity of billed items.',
  'bo.metric.totalCollected': 'Total collected',
  'bo.metric.totalCollected.desc': 'What guests paid: sales + service + tax + rounding.',
  'bo.metric.serviceCharge': 'Service charge',
  'bo.metric.serviceCharge.desc': 'Service charge on settled bills.',
  'bo.metric.tax': 'Tax',
  'bo.metric.tax.desc': 'Restaurant tax (PB1) on settled bills.',
  'bo.metric.rounding': 'Rounding',
  'bo.metric.cancelledItems': 'Cancelled items',
  'bo.metric.refunds': 'Refunds',
  'bo.nav.audit': 'Audit trail',
  'bo.audit.title': 'Audit trail',
  'bo.audit.subtitle': 'Who did what, when and why in {branch}. Newest first.',
  'bo.audit.search': 'Person, action, reason or detail',
  'bo.audit.area': 'Area',
  'bo.audit.area.all': 'All areas',
  'bo.audit.area.payments': 'Payments and refunds',
  'bo.audit.area.bills': 'Bills',
  'bo.audit.area.orders': 'Orders and items',
  'bo.audit.area.shifts': 'Cash shifts',
  'bo.audit.area.stock': 'Stock',
  'bo.audit.area.settings': 'Branch settings',
  'bo.audit.col.time': 'Time',
  'bo.audit.col.actor': 'Person',
  'bo.audit.col.action': 'Action',
  'bo.audit.col.reason': 'Reason',
  'bo.audit.col.details': 'Details',
  'bo.audit.showDetails': 'Show',
  'bo.audit.more': 'Load older entries',
  'bo.audit.loading': 'Loading…',
  'bo.audit.action.paymentRecorded': 'Payment recorded',
  'bo.audit.action.paymentRefunded': 'Refund given',
  'bo.audit.action.billSettled': 'Bill settled',
  'bo.audit.action.billVoided': 'Bill voided',
  'bo.audit.action.orderCancelled': 'Order cancelled',
  'bo.audit.action.itemCancelled': 'Item cancelled',
  'bo.audit.action.itemCancelledWasted': 'Item cancelled (wasted)',
  'bo.audit.action.shiftOpened': 'Shift opened',
  'bo.audit.action.shiftClosed': 'Shift closed',
  'bo.audit.action.settingsUpdated': 'Settings changed',
  'bo.metric.netReceived': 'Net received',
  'bo.metric.cancelledItems.desc': 'Items cancelled after being sent to the kitchen.',

  // ---- Dashboard ---------------------------------------------------------------------
  'bo.dashboard.title': 'Dashboard',
  'bo.dashboard.subtitle': '{branch} · {range}',
  'bo.dashboard.noPermission':
    'Your role cannot view sales figures. Use the menu on the left for the areas you manage.',
  'bo.dashboard.empty':
    'No sales in this range yet — data appears after the first bill is settled.',
  'bo.chart.titleDaily': 'Gross sales per day',
  'bo.chart.titleHourly': 'Gross sales per hour',
  'bo.chart.description': 'Hover or focus the chart and use ← → to see each point.',
  'bo.chart.billsInTooltip': 'Bills (in the tooltip)',
  'bo.chart.endLabel': 'Sales',
  'bo.chart.ariaDaily':
    'Area chart of gross sales per day, {range}. Total {total}; highest {peak} on {peakAt}.',
  'bo.chart.ariaHourly':
    'Area chart of gross sales per hour, {range}. Total {total}; highest {peak} at {peakAt}.',
  'bo.chart.keyboardHint': '{label} Use the left and right arrow keys to read each point.',
  'bo.chart.pointAnnounce': '{title}: gross sales {value}, {bills} bills',
  'bo.topItems.title': 'Top items',
  'bo.topItems.description': 'Best sellers by gross sales.',
  'bo.topItems.meta': '{quantity} sold',
  'bo.byCategory.title': 'Sales by category',
  'bo.byCategory.description': 'Gross sales per menu category.',

  // ---- Floors & tables ---------------------------------------------------------------
  'bo.floors.title': 'Floors & tables',
  'bo.floors.subtitle': 'Dining areas and tables of {branch}.',
  'bo.floors.readOnly': 'Your role can view the floor plan but not change it.',
  'bo.floors.add': 'Add floor',
  'bo.floors.listTitle': 'Floors',
  'bo.floors.listDesc': 'Areas that group tables (e.g. indoor, terrace).',
  'bo.floors.empty': 'No floors yet — add a floor, then add its tables.',
  'bo.floors.meta': '{count} tables · order {order}',
  'bo.floors.editNamed': 'Edit floor {name}',
  'bo.floors.createTitle': 'Add floor',
  'bo.floors.editTitle': 'Edit floor',
  'bo.floors.formDesc': 'Floors group tables on the service and cashier screens.',
  'bo.floors.name': 'Floor name',
  'bo.floors.saved': 'Floor {name} saved.',
  'bo.tables.add': 'Add table',
  'bo.tables.listTitle': 'Tables',
  'bo.tables.listDesc': 'Status is live; only available ↔ out of service can be set here.',
  'bo.tables.empty': 'No tables yet — add tables so service staff can seat guests.',
  'bo.tables.emptyNoFloor': 'Add a floor first; tables belong to a floor.',
  'bo.tables.col.name': 'Table',
  'bo.tables.col.floor': 'Floor',
  'bo.tables.col.capacity': 'Seats',
  'bo.tables.col.status': 'Status',
  'bo.tables.markOutOfService': 'Out of service',
  'bo.tables.markAvailable': 'Make available',
  'bo.tables.statusChanged': 'Table {name} is now {status}.',
  'bo.tables.editNamed': 'Edit table {name}',
  'bo.tables.createTitle': 'Add table',
  'bo.tables.editTitle': 'Edit table',
  'bo.tables.formDesc': 'Name and seats as shown to service staff.',
  'bo.tables.name': 'Table name',
  'bo.tables.nameHint': 'Short, e.g. M1 or T4.',
  'bo.tables.floorRequired': 'Choose a floor.',
  'bo.tables.capacityHint': '1 to 50 seats.',
  'bo.tables.capacityInvalid': 'Enter a number of seats from 1 to 50.',
  'bo.tables.activeLabel': 'Table in use',
  'bo.tables.activeHint': 'Inactive tables are hidden from the floor plan.',
  'bo.tables.saved': 'Table {name} saved.',
  'bo.tables.open': 'Open details',
  'bo.tableDetail.back': 'Back to floors and tables',
  'bo.tableDetail.subtitle': '{floor} · {branch}',
  'bo.tableDetail.capacityValue': '{count} seats',
  'bo.tableDetail.tabs': 'Table detail sections',
  'bo.tableDetail.analytics': 'Analytics',
  'bo.tableDetail.settings': 'Settings',
  'bo.tableDetail.noAccess': 'You do not have access to table details.',
  'bo.tableDetail.notFound': 'This table was not found in the current branch.',
  'bo.tableDetail.analyticsReadOnly': 'You do not have access to operational reports.',
  'bo.tableDetail.settingsReadOnly': 'You do not have permission to change table settings.',
  'bo.tableDetail.analyticsDesc':
    'Performance is calculated from table seatings and settled bills in the selected period.',
  'bo.tableDetail.range': 'Analytics period',
  'bo.tableDetail.days': '{count} days',
  'bo.tableDetail.sessions': 'Table turns',
  'bo.tableDetail.sessionsHint': 'Seatings opened during the period',
  'bo.tableDetail.netSales': 'Net sales',
  'bo.tableDetail.netSalesHint': 'Settled subtotal before service charge and tax',
  'bo.tableDetail.seatFill': 'Seat fill',
  'bo.tableDetail.seatFillHint': 'Guests divided by available seats per turn',
  'bo.tableDetail.averageTurn': 'Average dining time',
  'bo.tableDetail.averageTurnHint': 'Closed seatings only',
  'bo.tableDetail.guests': 'Guests',
  'bo.tableDetail.guestsHint': 'Recorded party sizes',
  'bo.tableDetail.averageParty': 'Average party',
  'bo.tableDetail.averagePartyHint': 'Guests per seating',
  'bo.tableDetail.spendPerGuest': 'Spend per guest',
  'bo.tableDetail.spendPerGuestHint': 'Settled net sales divided by guests',
  'bo.tableDetail.activity': 'Daily table turns',
  'bo.tableDetail.activityDesc': 'Each bar is the number of seatings opened that day.',
  'bo.tableDetail.activityAria': 'Daily table turns chart',
  'bo.tableDetail.noActivity': 'No table activity was recorded in this period.',
  'bo.tableDetail.recent': 'Recent seatings',
  'bo.tableDetail.recentDesc': 'The latest 20 seatings inside the selected period.',
  'bo.tableDetail.opened': 'Opened',
  'bo.tableDetail.server': 'Server',
  'bo.tableDetail.duration': 'Dining time',
  'bo.tableDetail.noSessions': 'No seatings were recorded in this period.',
  'bo.tableDetail.settingsTitle': 'Table settings',
  'bo.tableDetail.settingsDesc':
    'Control where this table appears and whether it can receive guests.',
  'bo.tableDetail.statusManaged': 'Service controls this status while a seating is active.',
  'bo.tableDetail.activeHint': 'Inactive tables are hidden from service floor plans.',
  'bo.tableDetail.manageQr': 'Manage guest QR code',
  'bo.tableDetail.saved': 'Table settings saved.',

  // ---- Menu --------------------------------------------------------------------------
  'bo.menu.title': 'Menu',
  'bo.menu.subtitle': 'Items, categories and modifiers sold at {branch}.',
  'bo.menu.readOnly': 'Your role can view the menu but not change it.',
  'bo.menu.tabs': 'Menu sections',
  'bo.menu.tab.items': 'Items',
  'bo.menu.tab.categories': 'Categories',
  'bo.menu.tab.modifiers': 'Modifier groups',
  'bo.categories.title': 'Categories',
  'bo.categories.description': 'Group items on the menu and route them to a kitchen station.',
  'bo.categories.add': 'Add category',
  'bo.categories.empty': 'No categories yet — add one before adding menu items.',
  'bo.categories.col.name': 'Category',
  'bo.categories.col.station': 'Default station',
  'bo.categories.col.items': 'Items',
  'bo.categories.editNamed': 'Edit category {name}',
  'bo.categories.createTitle': 'Add category',
  'bo.categories.editTitle': 'Edit category',
  'bo.categories.formDesc':
    'Items in this category go to its default station unless they set their own.',
  'bo.categories.stationHint': 'Where tickets for this category are prepared.',
  'bo.categories.stationNone': 'Branch default station',
  'bo.categories.activeLabel': 'Category in use',
  'bo.categories.activeHint': 'Inactive categories and their items are hidden when ordering.',
  'bo.categories.saved': 'Category {name} saved.',
  'bo.items.title': 'Menu items',
  'bo.items.description': 'Prices are per portion in the branch currency.',
  'bo.items.add': 'Add item',
  'bo.items.filter': 'Filter by category',
  'bo.items.allCategories': 'All categories',
  'bo.items.empty': 'No items in this category yet — add an item to sell it.',
  'bo.items.emptyNoCategory': 'Add a category first; every item belongs to a category.',
  'bo.items.col.name': 'Item',
  'bo.items.col.category': 'Category',
  'bo.items.col.station': 'Station',
  'bo.items.col.price': 'Price',
  'bo.items.col.prep': 'Prep time',
  'bo.items.col.availability': 'Availability',
  'bo.items.available': 'Available',
  'bo.items.soldOut': 'Sold out',
  'bo.items.markSoldOut': 'Mark sold out',
  'bo.items.markAvailable': 'Mark available',
  'bo.items.nowSoldOut': '{name} is marked sold out.',
  'bo.items.nowAvailable': '{name} is available again.',
  'bo.items.stationViaCategory': '{name} (category)',
  'bo.items.stationDefault': 'Branch default',
  'bo.items.editNamed': 'Edit {name}',
  'bo.items.createTitle': 'Add menu item',
  'bo.items.editTitle': 'Edit menu item',
  'bo.items.formDesc': 'Guests and staff see the name, description and price.',
  'bo.items.descriptionLabel': 'Description (optional)',
  'bo.items.imageUrlLabel': 'Photo URL',
  'bo.items.imageUrlHint': 'https link to the photo, e.g. from Unsplash. Leave empty for no photo.',
  'bo.items.imageUrlInvalid': 'Enter a full https:// link.',
  'bo.items.imageCreditNameLabel': 'Photo credit',
  'bo.items.imageCreditUrlLabel': 'Credit link',
  'bo.items.categoryRequired': 'Choose a category.',
  'bo.items.priceLabel': 'Price ({currency}, minor units)',
  'bo.items.priceHint': 'Digits only, in minor units — for IDR that is rupiah, e.g. 25000.',
  'bo.items.priceRequired': 'Enter a price.',
  'bo.items.priceInvalid': 'Enter the price as digits only.',
  'bo.items.priceNoPermission': 'Your role cannot change prices.',
  'bo.items.pricePreview': 'Shown as',
  'bo.items.stationHint': 'Leave on the category default unless this item is made elsewhere.',
  'bo.items.stationFromCategory': 'Use the category default',
  'bo.items.prepLabel': 'Prep time in minutes (optional)',
  'bo.items.prepHint': 'Used to flag late tickets in the kitchen.',
  'bo.items.prepInvalid': 'Enter minutes from 0 to 240, or leave empty.',
  'bo.items.modifiersLabel': 'Modifier groups',
  'bo.items.modifiersNone': 'No modifier groups yet — create them in the Modifier groups tab.',
  'bo.items.availableLabel': 'Available to order',
  'bo.items.availableHint': 'Untick when sold out for today.',
  'bo.items.activeLabel': 'On the menu',
  'bo.items.activeHint': 'Inactive items are hidden from the menu entirely.',
  'bo.items.saved': '{name} saved.',
  'bo.modifiers.title': 'Modifier groups',
  'bo.modifiers.description': 'Choices guests make for an item, such as spice level or extras.',
  'bo.modifiers.add': 'Add modifier group',
  'bo.modifiers.empty': 'No modifier groups yet — add one, then attach it to menu items.',
  'bo.modifiers.col.name': 'Group',
  'bo.modifiers.col.rule': 'Selection',
  'bo.modifiers.col.options': 'Active options',
  'bo.modifiers.col.items': 'Items',
  'bo.modifiers.required': 'Required',
  'bo.modifiers.inactiveCount': '+ {count} inactive',
  'bo.modifiers.ruleExactly': 'Choose exactly {count}',
  'bo.modifiers.ruleUpTo': 'Choose up to {max}',
  'bo.modifiers.ruleBetween': 'Choose {min}–{max}',
  'bo.modifiers.editNamed': 'Edit modifier group {name}',
  'bo.modifiers.createTitle': 'Add modifier group',
  'bo.modifiers.editTitle': 'Edit modifier group',
  'bo.modifiers.formDesc': 'Saving sends the full option list.',
  'bo.modifiers.nameHint': 'Shown to staff when ordering, e.g. "Spice level".',
  'bo.modifiers.minLabel': 'Minimum choices',
  'bo.modifiers.minHint': '0 = optional; 1 or more = required.',
  'bo.modifiers.maxLabel': 'Maximum choices',
  'bo.modifiers.maxHint': 'At least 1, at most 20.',
  'bo.modifiers.minInvalid': 'Enter a whole number from 0 to 20.',
  'bo.modifiers.maxInvalid': 'Enter a whole number from 1 to 20.',
  'bo.modifiers.minAboveMax': 'The minimum cannot be higher than the maximum.',
  'bo.modifiers.optionsLabel': 'Options',
  'bo.modifiers.optionsHint':
    'Options removed from this list are deactivated, not deleted — past orders keep them. Untick "Active" to hide an option instead.',
  'bo.modifiers.optionName': 'Option',
  'bo.modifiers.optionPrice': 'Price change',
  'bo.modifiers.optionActive': 'Active',
  'bo.modifiers.priceInvalid': 'Digits only; a leading minus for a discount.',
  'bo.modifiers.noExtraCharge': 'No extra charge',
  'bo.modifiers.optionsRequired': 'Add at least one option.',
  'bo.modifiers.optionsTooMany': 'Use at most 40 options.',
  'bo.modifiers.removeOption': 'Remove option {name}',
  'bo.modifiers.removedWarning':
    '{count} existing option(s) removed from the list will be deactivated when you save.',
  'bo.modifiers.addOption': 'Add option',
  'bo.modifiers.activeLabel': 'Group in use',
  'bo.modifiers.activeHint': 'Inactive groups are not offered when ordering.',
  'bo.modifiers.saved': 'Modifier group {name} saved.',
  'bo.menu.filter.allStations': 'All stations',
  'bo.menu.filter.allStatuses': 'All statuses',
  'bo.menu.filter.allAvailability': 'Any availability',
  'bo.menu.filter.allRules': 'All selection rules',
  'bo.categories.searchPlaceholder': 'Category or station',
  'bo.items.searchPlaceholder': 'Item, description, category or station',
  'bo.items.emptyNone': 'No menu items yet — add an item to sell it.',
  'bo.items.col.description': 'Description',
  'bo.modifiers.searchPlaceholder': 'Group or option',

  // ---- Kitchen stations --------------------------------------------------------------
  'bo.stations.title': 'Kitchen stations',
  'bo.stations.subtitle': 'Where tickets of {branch} are prepared.',
  'bo.stations.readOnly': 'Your role can view stations but not change them.',
  'bo.stations.add': 'Add station',
  'bo.stations.listTitle': 'Stations',
  'bo.stations.listDesc': 'Each station gets its own ticket list on the kitchen display.',
  'bo.stations.empty': 'No stations yet — add one so the kitchen display can show tickets.',
  'bo.stations.col.name': 'Station',
  'bo.stations.col.default': 'Default',
  'bo.stations.col.items': 'Items routed',
  'bo.stations.defaultBadge': 'Default',
  'bo.stations.editNamed': 'Edit station {name}',
  'bo.stations.createTitle': 'Add station',
  'bo.stations.editTitle': 'Edit station',
  'bo.stations.formDesc': 'Items go to their own station, else their category’s, else the default.',
  'bo.stations.nameHint': 'E.g. Main kitchen, Bar, Grill.',
  'bo.stations.defaultLabel': 'Default station',
  'bo.stations.defaultHint': 'Receives items without a station of their own or of their category.',
  'bo.stations.activeLabel': 'Station in use',
  'bo.stations.activeHint': 'Inactive stations no longer receive tickets.',
  'bo.stations.saved': 'Station {name} saved.',

  // ---- Staff -------------------------------------------------------------------------
  'bo.staff.title': 'Staff',
  'bo.staff.subtitle': 'People who can sign in to {tenant}.',
  'bo.staff.readOnly': 'Your role can view staff but not add them.',
  'bo.staff.add': 'Add staff',
  'bo.staff.listTitle': 'Staff members',
  'bo.staff.listDesc': 'Roles decide which interfaces and actions each person can use.',
  'bo.staff.empty': 'No staff yet — add staff so they can sign in.',
  'bo.staff.searchPlaceholder': 'Name, email or role',
  'bo.staff.filter.allRoles': 'All roles',
  'bo.staff.filter.allBranches': 'All branches',
  'bo.staff.filter.allStatuses': 'All statuses',
  'bo.staff.roles.manageAction': 'Manage roles',
  'bo.staff.col.name': 'Name',
  'bo.staff.col.roles': 'Roles',
  'bo.staff.col.status': 'Status',
  'bo.staff.col.actions': 'Actions',
  'bo.staff.roles.title': 'Roles of {name}',
  'bo.staff.roles.desc':
    'Roles add up. A small team can give warehouse duties to someone it already has — e.g. Chef + Warehouse manager.',
  'bo.staff.roles.addRole': 'Add role',
  'bo.staff.roles.add': 'Add role',
  'bo.staff.roles.remove': 'Remove {role}',
  'bo.staff.roles.lastRole': 'A staff member needs at least one role.',
  'bo.staff.roles.granted': 'Role added.',
  'bo.staff.roles.revoked': 'Role removed.',
  'bo.staff.roleAt': '{role} · {branch}',
  'bo.staff.allBranches': 'All branches',
  'bo.staff.allBranchesHint': 'The role applies in every branch, including future ones.',
  'bo.staff.status.active': 'Active',
  'bo.staff.status.invited': 'Invited',
  'bo.staff.status.deactivated': 'Deactivated',
  'bo.staff.createTitle': 'Add staff member',
  'bo.staff.formDesc': 'They sign in with this e-mail and the initial password.',
  'bo.staff.email': 'Email',
  'bo.staff.emailRequired': 'Enter an email address.',
  'bo.staff.emailInvalid': 'Enter a valid email address.',
  'bo.staff.emailTaken': 'This person is already a staff member.',
  'bo.staff.password': 'Initial password',
  'bo.staff.passwordHint': 'At least 10 characters. Ignored if this email already has an account.',
  'bo.staff.passwordTooShort': 'Use at least 10 characters.',
  'bo.staff.role': 'Role',
  'bo.staff.branch': 'Branch',
  'bo.staff.submit': 'Add staff member',
  'bo.staff.saved': '{name} was added.',
  'bo.role.manager': 'Manager',
  'bo.role.cashier': 'Cashier',
  'bo.role.waiter': 'Waiter',
  'bo.role.host': 'Host',
  'bo.role.chef': 'Chef',
  'bo.role.inventory': 'Inventory',
  'bo.role.warehouse_manager': 'Warehouse manager',
  'bo.role.purchasing': 'Purchasing',
  'bo.role.finance': 'Finance',
  'bo.role.finance_manager': 'Finance manager',
  'bo.role.auditor': 'Auditor',
  'bo.role.administrator': 'Administrator',
  'bo.role.owner': 'Owner',

  // ---- Cash shifts -------------------------------------------------------------------
  'bo.shifts.title': 'Cash shifts',
  'bo.shifts.subtitle':
    'Cash drawer history of {branch}. Times in {timeZone}. Delivery payments go to the platform and are not counted as cash.',
  'bo.shifts.listTitle': 'Shift history',
  'bo.shifts.listDesc':
    'Expected = opening float + cash sales + pay-ins − pay-outs. Discrepancy = counted − expected.',
  'bo.shifts.empty': 'No cash shifts yet — they appear once a cashier opens a shift.',
  'bo.shifts.col.cashier': 'Cashier',
  'bo.shifts.col.opened': 'Opened',
  'bo.shifts.col.closed': 'Closed',
  'bo.shifts.col.float': 'Opening float',
  'bo.shifts.col.cashSales': 'Cash sales',
  'bo.shifts.col.payInOut': 'Pay in / out',
  'bo.shifts.col.expected': 'Expected',
  'bo.shifts.col.counted': 'Counted',
  'bo.shifts.col.discrepancy': 'Discrepancy',
  'bo.shifts.col.status': 'Status',
  'bo.shifts.payments': '{count} payments',
  'bo.shifts.short': 'Short',
  'bo.shifts.over': 'Over',

  // ---- Reports -----------------------------------------------------------------------
  'bo.reports.title': 'Reports',
  'bo.reports.subtitle': 'Sales of {branch} by business date ({timeZone}).',
  'bo.reports.rangeTitle': 'Date range',
  'bo.reports.rangeDesc': 'Business dates in the branch time zone, both days included.',
  'bo.reports.from': 'From',
  'bo.reports.to': 'To',
  'bo.reports.error.order': 'The start date must be on or before the end date.',
  'bo.reports.error.tooLong': 'Choose at most {max} days.',
  'bo.reports.error.future': 'The end date cannot be in the future.',
  'bo.reports.error.incomplete': 'Enter both dates.',
  'bo.reports.totalsTitle': 'Totals',
  'bo.reports.totalsDesc': 'Settled bills, {range}.',
  'bo.reports.col.metric': 'Metric',
  'bo.reports.col.value': 'Value',
  'bo.reports.col.date': 'Date',
  'bo.reports.col.method': 'Method',
  'bo.reports.col.amount': 'Amount',
  'bo.reports.col.received': 'Received',
  'bo.reports.col.category': 'Category',
  'bo.reports.col.item': 'Item',
  'bo.reports.col.quantity': 'Qty',
  'bo.reports.byDayTitle': 'By day',
  'bo.reports.byDayDesc': 'Days with settled bills.',
  'bo.reports.byPaymentTitle': 'By payment method',
  'bo.reports.byPaymentDesc': 'Amounts received on settled bills.',
  'bo.reports.receivedTitle': 'Money received by payment date',
  'bo.reports.receivedDesc':
    'Payments and refunds on the day the money moved. A bill paid on a later day counts here on that day.',
  'bo.reports.method.cash': 'Cash',
  'bo.reports.method.platform': 'Platform delivery',
  'bo.reports.byChannelTitle': 'Sales by channel',
  'bo.reports.byChannelDesc':
    'Settled bills by order type and delivery platform. Delivery orders are paid to the platform, not into the cash drawer.',
  'bo.reports.col.channel': 'Channel',
  'bo.reports.col.collected': 'Collected',
  'bo.reports.definitionsTitle': 'Definitions',
  'bo.reports.definitionsDesc': 'How each figure is calculated, as returned with this report.',
  'bo.reports.definitionsNone': 'The server returned no definitions for this report.',
  'bo.reports.notPnl':
    'Operational sales from settled bills — not an accounting profit & loss statement.',
  'bo.reports.def.scope': 'Scope',

  // ---- Branches ----------------------------------------------------------------------
  'bo.branches.title': 'Branches',
  'bo.branches.subtitle': 'Restaurants of {tenant}.',
  'bo.branches.add': 'Create branch',
  'bo.branches.listTitle': 'All branches',
  'bo.branches.listDesc': 'Branches you can access.',
  'bo.branches.count': '{count} branches you can access.',
  'bo.branches.empty': 'No branches yet — create the first branch to start setting up.',
  'bo.branches.emptyReadOnly':
    'No branches yet. An owner or manager with branch rights can create one.',
  'bo.branches.col.code': 'Code',
  'bo.branches.col.name': 'Name',
  'bo.branches.col.timeZone': 'Time zone',
  'bo.branches.col.currency': 'Currency',
  'bo.branches.col.locale': 'Language',
  'bo.branches.col.status': 'Status',
  'bo.branches.col.createdAt': 'Created',
  'bo.branches.sortBy': 'Sort by {column}',
  'bo.branches.createTitle': 'Create branch',
  'bo.branches.createDesc':
    'Time zone and currency are fixed once trading starts; business dates follow the time zone.',
  'bo.branches.codeHint': '2–16 upper-case letters, digits or dashes, e.g. JKT-02.',
  'bo.branches.timeZoneHint': 'Business days and report dates use this time zone.',
  'bo.branches.submit': 'Create branch',
  'bo.branches.created': 'Branch {name} created.',
  'bo.branches.error.codeRequired': 'Enter a branch code.',
  'bo.branches.error.codeFormat': 'Use 2–16 upper-case letters, digits or dashes.',
  'bo.branches.error.codeTaken': 'A branch with this code already exists.',
  'bo.branches.error.nameRequired': 'Enter a branch name.',
  'bo.branches.error.timeZone': 'Unknown time zone.',
  'bo.branches.error.currency': 'This currency is not supported.',

  // ---- Settings ----------------------------------------------------------------------
  'bo.settings.title': 'Settings',
  'bo.settings.subtitle': 'Branch settings of {branch}.',
  'bo.settings.readOnly': 'Your role can view these settings but not change them.',
  'bo.settings.cardTitle': 'Billing',
  'bo.settings.cardDesc': 'Name, tax, service charge and cash rounding used on new bills.',
  'bo.settings.name': 'Branch name',
  'bo.settings.tax': 'Tax (PB1)',
  'bo.settings.service': 'Service charge',
  'bo.settings.percentHint': 'Percent with up to 2 decimals, e.g. 10 or 5,5.',
  'bo.settings.percentInvalid': 'Enter a percentage from 0 to 50 with at most 2 decimals.',
  'bo.settings.bpsHint': 'Stored as {bps} basis points.',
  'bo.settings.rounding': 'Rounding unit ({currency}, minor units)',
  'bo.settings.roundingHint': 'Bill totals are rounded to this amount; 1 = no rounding.',
  'bo.settings.roundingNone': 'No rounding.',
  'bo.settings.roundingTo': 'Totals are rounded to',
  'bo.settings.roundingInvalid': 'Enter a whole number from 1 to 100000.',
  'bo.settings.wasteThreshold': 'Waste approval threshold ({currency}, minor units)',
  'bo.settings.wasteThresholdHint':
    'Waste records with an estimated value at or above this amount need a second person to approve them.',
  'bo.settings.wasteThresholdAll': '0 = every waste record needs approval.',
  'bo.settings.wasteThresholdFrom': 'Approval needed from',
  'bo.settings.wasteThresholdInvalid': 'Enter a whole number of 0 or more.',
  'bo.settings.autoSoldOut': 'Sold out automatically when stock runs out',
  'bo.settings.autoSoldOutHint':
    'Every minute, dishes whose recipe cannot be made from the consumption location are marked sold out, and back once restocked. A sold-out set by staff is never changed.',
  'bo.settings.refundThreshold': 'Refund approval threshold ({currency}, minor units)',
  'bo.settings.refundThresholdHint':
    'Refunds at or above this amount must be done by someone who can approve refunds (a manager).',
  'bo.settings.refundThresholdAll': '0 = every refund is done by a manager.',
  'bo.settings.refundThresholdFrom': 'Manager needed from',
  'bo.settings.separationOfDuties': 'Separation of duties',
  'bo.settings.separationOfDutiesHint':
    'On: whoever counted stock, recorded waste or requested goods cannot approve it — another person must. Off (small teams): they may approve their own, with a reason; it is logged as a self-approval.',
  'bo.settings.appliesNote':
    'Changes apply to bills created after saving; existing bills keep their rates.',
  'bo.settings.submit': 'Save settings',
  'bo.settings.saved': 'Branch settings saved.',
  'bo.settings.conflict':
    'Someone else changed these settings in the meantime. The latest values are loaded — check them and save again.',
  // ---- Promotions (guest menu) ----------------------------------------------------------
  'bo.nav.guestContacts': 'Guest contacts',
  'bo.contacts.title': 'Guest contacts',
  'bo.contacts.subtitle': 'Guests who left a phone number when ordering from the table QR menu.',
  'bo.contacts.rules':
    'Only send promotions to guests marked “Agreed”. They ticked a separate box to allow it. If a guest asks to stop or to be forgotten, withdraw the consent or delete the contact here.',
  'bo.contacts.readOnly':
    'You can view contacts; withdrawing consent and deleting need customer management access.',
  'bo.contacts.search': 'Search name or number',
  'bo.contacts.empty': 'No guest has left a phone number yet.',
  'bo.contacts.col.name': 'Name',
  'bo.contacts.col.phone': 'Phone',
  'bo.contacts.col.consent': 'Promotions',
  'bo.contacts.col.consentAt': 'Consent',
  'bo.contacts.col.orders': 'Orders',
  'bo.contacts.col.lastOrder': 'Last order',
  'bo.contacts.allConsent': 'Everyone',
  'bo.contacts.consentYes': 'Agreed',
  'bo.contacts.consentNo': 'Not agreed',
  'bo.contacts.withdrawnAt': 'Withdrawn {date}',
  'bo.contacts.withdraw': 'Withdraw consent',
  'bo.contacts.withdrawTitle': 'Withdraw consent',
  'bo.contacts.withdrawBody':
    '{name} will no longer receive promotions. The contact stays in the list.',
  'bo.contacts.withdrawn': '{name} will no longer receive promotions.',
  'bo.contacts.delete': 'Delete contact',
  'bo.contacts.deleteTitle': 'Delete contact',
  'bo.contacts.deleteBody':
    'The name and number of {name} are deleted for good. Past orders keep only the name.',
  'bo.contacts.deleted': 'Contact deleted.',
  'bo.contacts.error': 'That didn’t work. Reload and try again.',
  'bo.nav.promotions': 'Promotions',
  'bo.promo.title': 'Promotions',
  'bo.promo.subtitle':
    'Shown at the top of the guest QR menu. A promotion never changes a price — discounts are applied at the cashier.',
  'bo.promo.readOnly': 'You can view promotions. Changing them needs menu management rights.',
  'bo.promo.new': 'New promotion',
  'bo.promo.edit': 'Edit promotion',
  'bo.promo.empty': 'No promotions yet — create one to show it on the guest menu.',
  'bo.promo.col.promotion': 'Promotion',
  'bo.promo.col.window': 'Shown',
  'bo.promo.col.status': 'Status',
  'bo.promo.field.title': 'Title',
  'bo.promo.field.description': 'Description',
  'bo.promo.field.badge': 'Badge',
  'bo.promo.field.badgeHint': 'Short label on the card, e.g. "Save 20%" or "New".',
  'bo.promo.field.image': 'Image URL (https)',
  'bo.promo.field.item': 'Menu item',
  'bo.promo.field.itemHint': 'Guests can jump from the promotion to this item.',
  'bo.promo.field.noItem': 'None',
  'bo.promo.field.startsAt': 'Show from',
  'bo.promo.field.endsAt': 'Show until',
  'bo.promo.field.windowHint': 'Leave empty to show right away / until switched off.',
  'bo.promo.always': 'Always',
  'bo.promo.from': 'From {date}',
  'bo.promo.until': 'Until {date}',
  'bo.promo.between': '{from} – {to}',
  'bo.promo.status.live': 'LIVE',
  'bo.promo.status.scheduled': 'SCHEDULED',
  'bo.promo.status.ended': 'ENDED',
  'bo.promo.status.off': 'OFF',
  'bo.promo.created': 'Promotion created.',
  'bo.promo.saved': 'Promotion saved.',
  'bo.promo.activate': 'Switch on',
  'bo.promo.deactivate': 'Switch off',
  'bo.promo.switchedOn': '{title} is shown again.',
  'bo.promo.switchedOff': '{title} is hidden from guests.',
  'bo.promo.error.window': 'The end must be after the start.',

  // ---- Table QR codes ----------------------------------------------------------------------
  'bo.nav.qr': 'Table QR codes',
  'bo.qr.title': 'Table QR codes',
  'bo.qr.subtitle':
    'Every table has its own code; all of them open the same branch menu. Guests see promotions, their table bill and can pay in the app.',
  'bo.qr.print': 'Print',
  'bo.qr.open': 'Open',
  'bo.qr.rotate': 'New code',
  'bo.qr.rotateTitle': 'Replace the QR code of table {table}?',
  'bo.qr.rotateBody':
    'The printed code stops working immediately. Print and place the new code on the table.',
  'bo.qr.rotated': 'Table {table} has a new QR code. Print it again.',
  'bo.qr.inactive': 'INACTIVE',
  'bo.qr.scanHint': 'Scan for the menu & bill',
  'bo.qr.empty': 'No tables yet — add tables under Floors & tables first.',
  'bo.qr.qrLabel': 'QR code for table {table}',
  'bo.reports.method.online': 'Online (guest app)',
  'bo.reports.method.qris': 'QRIS',
  'bo.reports.method.transfer': 'Bank transfer',
  'bo.reports.method.card': 'Card (EDC)',
  'bo.promo.listTitle': 'All promotions',
  'bo.promo.listDesc':
    'What the guest menu shows and when. Switch a promotion off to hide it without deleting it.',
  'bo.promo.searchPlaceholder': 'Title, badge or menu item',
  'bo.promo.allStatuses': 'All statuses',
  'bo.promo.editNamed': 'Edit {title}',
  // ---- List tables: floors, stations, shifts -----------------------------------------
  'bo.list.allStatuses': 'All statuses',
  'bo.list.allActive': 'Active & inactive',
  'bo.floors.col.tables': 'Tables',
  'bo.floors.search': 'Floor name',
  'bo.tables.search': 'Table or floor',
  'bo.tables.allFloors': 'All floors',
  'bo.stations.search': 'Station name',
  'bo.shifts.search': 'Cashier or note',
  'bo.shifts.allCashiers': 'All cashiers',
  'bo.shifts.col.note': 'Note',
  'bo.shifts.col.payIn': 'Pay in',
  'bo.shifts.col.payOut': 'Pay out',
  'bo.shifts.col.payments': 'Payments',
  'bo.settings.requisitionThreshold':
    'Kitchen request approval threshold ({currency}, minor units)',
  'bo.settings.requisitionThresholdNever': 'Empty = kitchen requests never need approval.',
  'bo.settings.requisitionThresholdHint':
    'Kitchen requests valued at or above this amount need approval.',
} as const;
